<ui-form-chip-filter-group
  (selectedChange)="selectedChanged($event)"
  [filterChips]="filterChips()"
  [selected]="selectedChips()"
  [totalCount]="totalItemsCount()"
  allLabel="Alle Kategorien"
></ui-form-chip-filter-group>
